// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"501":"bc98253f","4316":"ad2866b8"}[chunkId] || chunkId) + "." + {"501":"06dd6805e77e797b","2121":"41b3725bde199c95","2831":"d3d5f28b3983d1eb","4316":"0eac8b3573f42d9a"}[chunkId] + ".js";
};